import React from 'react';
import PropTypes from 'prop-types';

import { Link, Text, Box } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './story-cards.module.less';

const StoryCard = ({ title, linkUrl, previewImg }) => (
  <li className={styles['story-card__cont']}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-card-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <div className={styles['story-card-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <Box className={styles['story-card-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Box className={styles['story-card-title']}>
          <Text>{title}</Text>
        </Box>
      </Link>
    </Box>
  </li>
);

StoryCard.displayName = 'StoryCard';

StoryCard.propTypes = {
  title: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

StoryCard.defaultProps = {
  title: '',
  linkUrl: '',
  previewImg: '',
};

StoryCard.getEditingConfig = () => [
  titleInput,
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default StoryCard;
